var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.inputField
    ? _c("input", {
        ref: "input",
        attrs: {
          name: _vm.inputField,
          disabled: _vm.inputDisabled,
          autocomplete: "off",
        },
      })
    : _c("div", { ref: "datePicker" })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }